import { Refinement } from 'lib/Refinement/types'

import CustomReviewsRefinementList from 'components/Filters/ReviewsFilter/CustomReviewsRefinementList'

export const KEY = 'publicFilters.reviews.countBuckets'

export const reviewsFilterRefinement: Refinement = {
  getQueryParamValue: ({ refinementList }) =>
    refinementList &&
    refinementList[KEY] && {
      reviews: refinementList[KEY].join('_'),
    },
  getStateValue: ({ reviews }) =>
    reviews && {
      refinementList: {
        [KEY]: (reviews as string).split('_'),
      },
    },
}

const ReviewsFilter = (): JSX.Element => (
  <CustomReviewsRefinementList attribute={KEY} />
)

export default ReviewsFilter
